(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/welcome.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/welcome.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Welcome = Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.welcome(data);
    },

    regions: {
      startComponentRegion: '#startcomponentregion'
    },

    initialize: function() {
      this.startPageConfig = this.getStartPageOptions();
    },

    onAttach: function() {
      svs.maltipset.controllers.maltipsetController.initContextMenu({
        isStartPage: true
      });
      this.showChildView(
        'startComponentRegion',
        new svs.app.productStartPage.ProductStartPage(this.startPageConfig)
      );
    },

    getStartPageOptions: function() {
      var self = this,
        currentDraw =
          svs.maltipset.collections.draws &&
          svs.maltipset.collections.draws.getFirstDraw() &&
          svs.maltipset.collections.draws.getFirstDraw().hasMatchData()
            ? svs.maltipset.collections.draws.getFirstDraw()
            : null,
        hasStartPageConfig = svs.utils.ns.isNamespace(
          'svs.maltipset.data.config.startPageConfig'
        ),
        noOpenDrawsInfoText =
          svs.maltipset.constants.START_PAGE.DEFAULT_NO_OPEN_DRAWS_INFO,
        backGroundImage = '',
        options,
        configTabs = null,
        configFooterLinks = null,
        baseUrl = svs.core.data.baseUrl;

      if (hasStartPageConfig) {
        var startPageConfig = svs.maltipset.data.config.startPageConfig;
        noOpenDrawsInfoText = startPageConfig.promo.startPageBackgroundText
          .NoOpenDrawsInfo
          ? startPageConfig.promo.startPageBackgroundText.NoOpenDrawsInfo
          : noOpenDrawsInfoText;
        backGroundImage = startPageConfig.promo.startPageBackground.url
          ? startPageConfig.promo.startPageBackground.url
          : '';
        configTabs = startPageConfig.tabs ? startPageConfig.tabs : null;
        configFooterLinks = startPageConfig.links
          ? new Backbone.Collection(startPageConfig.links)
          : null;
      }

      options = {
        generalSettings: {
          branding: svs.maltipset.constants.START_PAGE.BRANDING
        },
        promoRegion: {
          defaultPromo: {
            items: new Backbone.Collection([
              {
                backgroundImageLarge: backGroundImage,
                noOpenDrawsText: noOpenDrawsInfoText,
                showNoOpenDraws: currentDraw ? false : true,
                theme: 'inverted',
                mobileFixedHeight: true,
                textRows: this.getPromoText(currentDraw),
                buttons: [
                  {
                    label: 'Spela Måltipset',
                    href: baseUrl + '/spela',
                    callback: function(e) {
                      e.preventDefault();
                      self.routePlay();
                    }
                  },
                  {
                    label: 'Xperten',
                    callback: function() {
                      self.xpertClicked();
                    }
                  },
                  {
                    label: 'Systemspel',
                    callback: function() {
                      self.systemClicked();
                    }
                  },
                  {
                    label: 'Förläng spel',
                    callback: function() {
                      self.showProlong();
                    }
                  },
                  {
                    label: 'Externa Systemspel',
                    href: baseUrl + '/externa-systemspel',
                    callback: function(e) {
                      e.preventDefault();
                      window.location.href = '/externa-systemspel';
                    }
                  }
                ]
              }
            ])
          }
        },
        tabRegion: this.getTabRegionConfig(configTabs),
        footerRegion: this.getFooterRegionConfig(configFooterLinks)
      };

      return options;
    },
    routePlay: function() {
      Backbone.history.navigate('spela', { trigger: true });
    },
    xpertClicked: function() {
      svs.core.deviceSession.set(
        'openXpertenFromWelcome',
        'Maltipset',
        true,
        function() {
          Backbone.history.navigate('spela', {
            trigger: true
          });
        }
      );
    },

    systemClicked: function() {
      svs.core.deviceSession.set(
        'openSystemFromWelcome',
        'Maltipset',
        true,
        function() {
          Backbone.history.navigate('spela', {
            trigger: true
          });
        }
      );
    },

    showProlong: function() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        this.prolongWagers =
          this.prolongWagers || new svs.maltipset.collections.ProlongWagers();
        var model = new Backbone.Model({
          hasOngoingGames: this.prolongWagers.hasOngoingGames
        });
        svs.components.Modal.show(
          svs.maltipset.views.Prolong,
          { model: model, collection: this.prolongWagers },
          {
            title: 'Förläng spel',
            headerClass: 'maltipset-modal-header',
            triggerScrollEnd: true,
            rightButton: { visible: false },
            leftButton: {
              visible: true,
              text: 'Avbryt',
              cssClass: 'btn-transparent-inverted'
            }
          }
        );
      } else {
        svs.components.customer_login.login();
      }
    },

    getTabRegionConfig: function(configTabs) {
      var config = null;
      if (configTabs) {
        config = new Backbone.Model({
          items: configTabs,
          buttons: [
            {
              label: 'Spela',
              inverted: false
            }
          ]
        });
      }
      return config;
    },

    getFooterRegionConfig: function(configFooter) {
      var config = null;
      if (configFooter) {
        config = {
          buttons: configFooter
        };
      }
      return config;
    },

    getPromoText: function(currentDraw) {
      var currentNetSale =
          currentDraw && currentDraw.get('currentNetSaleFormatted')
            ? currentDraw.get('currentNetSaleFormatted')
            : '',
        stopTime =
          currentDraw && currentDraw.get('regCloseTime')
            ? svs.utils.date.ShortDateAndTime(
              currentDraw.get('regCloseTime'),
              false
            )
            : undefined,
        jackpot = svs.maltipset.data.jackpot,
        promoTxt = [];
      if (jackpot) {
        promoTxt = [
          '',
          'Jackpot:',
          jackpot,
          'Omsättning: ' + currentNetSale + ' kr',
          'Spelstopp: ' + stopTime
        ];
      } else {
        promoTxt = [
          '',
          'Omsättning:',
          currentNetSale + ' kr',
          '',
          'Spelstopp: ' + stopTime
        ];
      }
      return promoTxt;
    },

    removeProlongWagers: function() {
      this.prolongWagers = undefined;
    }
  });
})(Backbone, _, svs);

 })(window);